<template>
  <div class="child-container w-100">
    <div class="activity-header">
      <span>Polls created by {{ name }}</span>
    </div>
    <div v-if="loading" class="d-flex align-items-center flex-column justify-content-center mt-4">
      <div>
        <div class="spinner-border spinner-class"></div>
      </div>
    </div>
    <div v-if="!loading">
      <div v-if="updates.length > 0">
        <div v-for="(update, index) in updates" :key="index">
          <div v-if="update.content_type === 'poll'">
            <PollCard :pollData="{ ...update, postId: update.id }" :fetchPosts="fetch" :fromProfilePolls="true" />
          </div>
        </div>
        <span class="viewmore cp" v-if="updates.length != pagination.total_count" :style="{ color: getPrimaryColor(), textAlign: 'center', display: 'block' }" @click="fetch(true)"> View More </span>
      </div>
      <div v-if="updates.length === 0" class="dailogbox">
        <div class="dailogbox">
          <div class="dailog-wrapper">
            <span class="dailog">
              <span class="dailog text-capitalize">
                {{ viewUser.role === "hospital" ? viewUser.hospital_info.hospital_name : viewUser.role === "clinic" ? viewUser.clinic_info.clinic_name : viewUser.display_name }}
              </span>
              has not created any polls yet.
            </span>
          </div>
        </div>
      </div>
    </div>
    <PostFullScreen ref="PostFullScreen" :postData="currentPostData" />
    <CreateNewPostModal ref="CreateNewPostModal" :getPost="fetch" :showCongrats="showCongrats" :handleOtherModals="handleOtherModals" />
    <congrats :showInfoModal="showInfoModal" ref="Congrats" />
    <info ref="Info" />
    <createEvent ref="EventModal" :handleOtherModals="handleOtherModals" />
    <createJob ref="JobModal" :handleOtherModals="handleOtherModals" />
    <createPressRelease ref="PressModal" :handleOtherModals="handleOtherModals" />
  </div>
</template>

<script>
import PollCard from "../../../home/poll/UserPollCard.vue"
import { RepositoryFactory } from "../../../../repositories/RepositoryFactory"
import PostFullScreen from "../../../Modals/activity/PostFullScreen.vue"
import CreateNewPostModal from "../../../Modals/CreateNewPost.vue"
import Congrats from "../../../Modals/activity/Congrats.vue"
import Info from "../../../Modals/activity/Info.vue"
import createEvent from "../../../Modals/createEvent.vue"
import createJob from "../../../Modals/createJob.vue"
import createPressRelease from "../../../Modals/createPressRelease.vue"

const UserRepository = RepositoryFactory.get("user")
const PostRepository = RepositoryFactory.get("posts")

export default {
  name: "ViewDoctorProfilePolls",
  components: {
    PollCard,
    PostFullScreen,
    Congrats,
    CreateNewPostModal,
    Info,
    createEvent,
    createJob,
    createPressRelease,
  },
  data() {
    return {
      updates: [],
      pagination: null,
      currentPage: 2,
      limit: 2,
      userId: null,
      user: null,
      inCircle: false,
      postPayload: {
        post_text: "",
        day_type: "",
      },
      loading: false,
      showNo: false,
      name: "",
    }
  },

  created() {
    console.warn("ViewDoctorProfilePolls.vue created")
    this.name =
      this.viewUser.role === "hospital"
        ? this.viewUser.hospital_info.hospital_name
        : this.viewUser.role === "clinic"
        ? this.viewUser.clinic_info.clinic_name
        : this.viewUser.role === "nfp"
        ? this.viewUser.nfp_info.nfp_name
        : this.viewUser.display_name
        ? this.viewUser.display_name
        : this.viewUser.doctor_info.full_name
    // this.name = this.name.replace(/\b(\w)/g, s => s.toUpperCase())
    this.userId = this.$route.params.id
    this.fetch()
  },

  methods: {
    showFullScreen(d) {
      this.$refs.PostFullScreen.show(d)
    },

    showCongrats() {
      this.$refs.Congrats.show()
    },
    showInfoModal() {
      this.$refs.Info.show()
    },

    pushToHome() {
      this.$router.push({ name: "createPollModal" })
    },

    fetch(append = false) {
      if (append) {
        UserRepository.getPollsByUser(this.currentPage, this.limit, this.viewUser.id, this.currentCircle.id, this.viewUser.role).then(res => {
          console.log(res, "inside 2nd one")
          this.updates.push(...res.data.data.data)
          this.pagination = res.data.data.paginator ? res.data.data.paginator : {}
          this.currentPage += 1
        })
      } else {
        this.loading = true
        this.updates = []
        UserRepository.getPollsByUser(1, this.limit, this.viewUser.id, this.currentCircle.id, this.viewUser.role).then(res => {
          if (res.data) {
            this.updates = res.data.data.data ? res.data.data.data : []
            this.loading = false
            this.pagination = res.data.data.paginator ? res.data.data.paginator : {}
          }
        })
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.activity-header {
  font-family: "Lato";
  font-style: normal;
  font-weight: 700;
  font-size: 32px;
  line-height: 42px;
  color: #0f1734;
  // position: absolute;
  // top:-92px;
  // left: 0px;
  margin-bottom: 32px;
}
.viewmore {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 8px;
  gap: 4px;
  font-weight: 700;
  font-size: 14px;
  line-height: 24px;
  margin-bottom: 20px;
  background: #f1f5f9;
  border-radius: 8px;
}
.dailog {
  font-weight: 700;
  font-size: 16px;
  line-height: 24px;
  text-align: center;
  color: #33415f;
}

.dailog-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0px;
  gap: 8px;
  width: 100%;
  // height: 115px;
}

.dailogbox {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 24px;
  gap: 24px;
  width: 100%;
  // height: 163px;
  background: #f1f5f9;
  border-radius: 8px;
}
</style>



// WEBPACK FOOTER //
// src/components/Users/Doctor/view/ViewDoctorProfilePolls.vue